import get from 'lodash/get';

import type { SumSubCheckStatus } from './types';

const statusChangeMessages = new Set([
  // Kept for backwards compatibility with SDK 1.0
  'idCheck.applicantStatus',
  'idCheck.onApplicantStatusChanged',
]);

export function getSumSubCheckStatus(message: string, payload: unknown): SumSubCheckStatus {
  if (message === 'idCheck.applicantReviewComplete') {
    return 'reviewCompleted';
  }

  if (
    statusChangeMessages.has(message) &&
    get(payload, 'reviewStatus') === 'completed' &&
    get(payload, 'reviewResult.reviewAnswer') === 'GREEN'
  ) {
    return 'success';
  }

  return 'unknown';
}
